// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { cn } from '@/lib/utils'

interface CardProps {
  children:    React.ReactNode
  className?:  string
  onClick?:    () => void
  hoverable?:  boolean
  padding?:    'none' | 'sm' | 'md' | 'lg'
}

const paddings = {
  none: '',
  sm:   'p-4',
  md:   'p-5',
  lg:   'p-6',
}

export function Card({ children, className, onClick, hoverable, padding = 'md' }: CardProps) {
  const Component = onClick ? 'button' : 'div'

  return (
    <Component
      onClick={onClick}
      className={cn(
        'w-full rounded-2xl bg-white border border-sand-300 shadow-soft',
        'text-left',
        hoverable && 'transition-all duration-200 ease-soft hover:shadow-elevated hover:border-sage-200 hover:-translate-y-0.5 cursor-pointer',
        paddings[padding],
        className,
      )}
    >
      {children}
    </Component>
  )
}

export function CardHeader({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <div className={cn('mb-4', className)}>
      {children}
    </div>
  )
}

export function CardTitle({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <h3 className={cn('text-base font-semibold text-ink', className)}>
      {children}
    </h3>
  )
}

export function CardDescription({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <p className={cn('text-sm text-ink-3 mt-0.5', className)}>
      {children}
    </p>
  )
}
